import { render, staticRenderFns } from "./StatusDialogStatuses.vue?vue&type=template&id=10f42ea8&scoped=true"
import script from "./StatusDialogStatuses.vue?vue&type=script&lang=js"
export * from "./StatusDialogStatuses.vue?vue&type=script&lang=js"
import style0 from "./StatusDialogStatuses.vue?vue&type=style&index=0&id=10f42ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f42ea8",
  null
  
)

export default component.exports